import { Controller } from "@hotwired/stimulus";

// Keeps the start/end date fields in sync with the selected range option:
// picking an option fills the dates, editing a date switches to "Custom range".
export default class extends Controller {
  connect() {
    this.onInput = (event) => {
      if (event.target.matches('[data-calendar-dropdown-target="input"]')) {
        this.markCustom();
      }
    };
    this.onClick = (event) => {
      if (event.target.closest('[data-action~="calendar-dropdown#select"]')) {
        this.markCustom();
      }
    };
    this.element.addEventListener("input", this.onInput);
    this.element.addEventListener("click", this.onClick);
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput);
    this.element.removeEventListener("click", this.onClick);
  }

  applyMode(event) {
    if (event.target.value !== "custom") {
      const { startValue, startLabel, endValue, endLabel } = event.params;
      this.setField("start_date", startValue, startLabel);
      this.setField("end_date", endValue, endLabel);
    }
    this.syncActive();
  }

  markCustom() {
    const custom = this.modeInput("custom");
    if (custom && !custom.checked) {
      custom.checked = true;
    }
    this.syncActive();
  }

  setField(field, value, label) {
    const hidden = this.element.querySelector(
      `[name="report_date_range[${field}]"]`,
    );
    if (!hidden) return;
    hidden.value = value || "";
    const input = hidden
      .closest(".calendar-dropdown")
      ?.querySelector('[data-calendar-dropdown-target="input"]');
    if (input) input.value = label || "";
  }

  syncActive() {
    const checked = this.element.querySelector(
      'input[name="report_date_range[mode]"]:checked',
    );
    this.element
      .querySelectorAll("report-date-range-modes label")
      .forEach((label) => {
        const radio = label.querySelector('input[type="radio"]');
        label.toggleAttribute("active", radio === checked);
      });
  }

  modeInput(value) {
    return this.element.querySelector(
      `input[name="report_date_range[mode]"][value="${value}"]`,
    );
  }
}
